import {
  CANCEL_ONBOARDING,
  CLEAR_ONBOARDING_FORM_BY_ID,
  CLEAR_ONBOARDING_SUBMISSION,
  CREATE_COMPOSITE_INPUT_ELEMENT,
  CREATE_FORM_ACTION_ELEMENT,
  CREATE_FORM_INPUT_ELEMENT,
  CREATE_ONBOARDING_SUBMISSION,
  DELETE_COMPOSITE_INPUT_ELEMENT,
  DELETE_FORM_INPUT_ELEMENT,
  DELETE_ONBOARDING,
  EDIT_COMPOSITE_INPUT_ELEMENT,
  EDIT_FORM_INPUT_ELEMENT,
  GET_FORM_INPUT_ELEMENT_BY_ID,
  GET_ONBOARDING_ALL,
  GET_ONBOARDING_BY_ID,
  GET_ONBOARDING_FORM_BY_ID,
  GET_ONBOARDING_FORMS,
  START_ONBOARDING_EDIT,
  STOP_ONBOARDING_EDIT,
  SUBMIT_ONBOARDING,
  UPLOAD_ONBOARDING_DOCUMENT,
} from './onboardingActionTypes';

export const getOnboardingAll = (userId) => ({
  type: GET_ONBOARDING_ALL.ACTION,
  payload: userId,
});

export const getOnboardingById = (id) => ({
  type: GET_ONBOARDING_BY_ID.ACTION,
  payload: id,
});

export const deleteOnboarding = (id) => ({
  type: DELETE_ONBOARDING.ACTION,
  payload: id,
});

export const getOnboardingForms = () => ({
  type: GET_ONBOARDING_FORMS.ACTION,
});

export const getOnboardingFormById = (data) => ({
  type: GET_ONBOARDING_FORM_BY_ID.ACTION,
  payload: data,
});

export const clearOnboardingFormById = () => ({
  type: CLEAR_ONBOARDING_FORM_BY_ID.ACTION,
});

export const clearOnboardingSubmission = () => ({
  type: CLEAR_ONBOARDING_SUBMISSION.ACTION,
});

export const createOnboardingSubmission = (data) => ({
  type: CREATE_ONBOARDING_SUBMISSION.ACTION,
  payload: data,
});

export const startOnboardingEdit = (id) => ({
  type: START_ONBOARDING_EDIT.ACTION,
  payload: id,
});

export const stopOnboardingEdit = (id) => ({
  type: STOP_ONBOARDING_EDIT.ACTION,
  payload: id,
});

export const getFormInputElementById = (id) => ({
  type: GET_FORM_INPUT_ELEMENT_BY_ID.ACTION,
  payload: id,
});

export const createFormInputElement = (data) => ({
  type: CREATE_FORM_INPUT_ELEMENT.ACTION,
  payload: data,
});

export const uploadOnboardingDocument = (data) => ({
  type: UPLOAD_ONBOARDING_DOCUMENT.ACTION,
  payload: data,
});

export const editFormInputElement = (data) => ({
  type: EDIT_FORM_INPUT_ELEMENT.ACTION,
  payload: data,
});

export const deleteFormInputElement = (id) => ({
  type: DELETE_FORM_INPUT_ELEMENT.ACTION,
  payload: id,
});

export const createCompositeInputElement = (data) => ({
  type: CREATE_COMPOSITE_INPUT_ELEMENT.ACTION,
  payload: data,
});

export const editCompositeInputElement = (data) => ({
  type: EDIT_COMPOSITE_INPUT_ELEMENT.ACTION,
  payload: data,
});

export const deleteCompositeInputElement = (id) => ({
  type: DELETE_COMPOSITE_INPUT_ELEMENT.ACTION,
  payload: id,
});

export const createFormActionElement = (data) => ({
  type: CREATE_FORM_ACTION_ELEMENT.ACTION,
  payload: data,
});

export const submitOnboarding = (id) => ({
  type: SUBMIT_ONBOARDING.ACTION,
  payload: id,
});

export const cancelOnboarding = (id) => ({
  type: CANCEL_ONBOARDING.ACTION,
  payload: id,
});